<script setup lang="ts">
import { computed } from 'vue';

import type { GuestRatingSummary } from './customersRatingTag.model';

interface CustomersRatingTagProps {
  guestRating: GuestRatingSummary;
  fontSize: 's' | 'l';
}
const props = defineProps<CustomersRatingTagProps>();

const guestScore = computed<string>(
  () => `${props.guestRating.overallScoreOverTen} / 10`
);
</script>

<template>
  <div class="customers-rating" :class="[props.fontSize]">
    <span class="rating">
      {{ guestScore }}
    </span>
    {{ $t('guest_rating', [props.guestRating.numberOfReviews]) }}
  </div>
</template>

<style scoped lang="scss">
.customers-rating {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  color: var(--color-neutral-70);
  &.s {
    @include font-label-s-light;
    .rating {
      @include font-label-s-bold;
    }
  }
  &.l {
    @include font-label-m-light;
    .rating {
      @include font-label-l-bold;
    }
  }
}
</style>
